import { PATH_URL } from './path-url';

const BASE = `${PATH_URL}/beneficios`;

/** URL de la imagen por categoría. Las keys coinciden con el `value` de CATEGORY_OPTIONS. */
export const CATEGORY_IMAGES: Record<string, string> = {
  'Ópticas y Ortopedias': `${BASE}/opticas-ortopedias.png`,
  Construcción: `${BASE}/construccion.png`,
  Supermercados: `${BASE}/supermercados.png`,
  Librerías: `${BASE}/librerias.png`,
  Alimentos: `${BASE}/alimentos.png`,
  'Farmacias y perfumerías': `${BASE}/farmacia.png`,
  Vinotecas: `${BASE}/vinos.png`,
  'Hogar y deco': `${BASE}/living.png`,
  Veterinarias: `${BASE}/veterinaria.png`,
  Jugueterías: `${BASE}/jugueteria.png`
};
